import request from '@/utils/request_xj'
import requestBbs from '@/utils/request'
// 获取短信验证码
export function getPhoneCode(data) {
    return request({
        url: '/api/official_auth/code',
        method: 'post',
        data
    })
}

// 获取邮箱验证码
export function getEmailCode(data) {
    return request({
        url: '/api/official_auth/MailCode',
        method: 'post',
        data
    })
}

// 手机号注册
export function register(data) {
    return request({
        url: '/api/official_auth/register',
        method: 'post',
        data
    })
}

// 邮箱注册
export function registerEmail(data) {
    return request({
        url: '/api/official_auth/mail_register',
        method: 'post',
        data
    })
}

// 实名认证
export function realName(data) {
    return request({
        url: '/api/official_auth/AuthName',
        method: 'post',
        data
    })
}

// 登录
export function login(data) {
    return request({
        url: '/api/official_auth/login',
        method: 'post',
        data
    })
}
// 获取用户信息
export function getUserinfo(data) {
    return request({
        url: '/api/official_auth/user_info',
        method: 'post',
        data
    })
}

// 邮箱订阅
export function subscribeEmail(data) {
    return request({
        url: '/api/official_auth/subscribe_email',
        method: 'post',
        data
    })
}

// 提交调查问卷
export function submitSurvey(data) {
    return request({
        url: '/api/official_auth/submit_survey',
        method: 'post',
        data
    })
}

// 新的问卷调查提交接口
export function submitSurveyNew(data) {
    return request({
        url: '/api/survey/submit',
        method: 'post',
        data
    })
}

// 提交收货信息
export function submitShipping(data) {
    return request({
        url: '/api/shipping/submit',
        method: 'post',
        data
    })
}

// 查询中奖状态
export function checkWinningStatus() {
    return request({
        url: '/api/official_auth/shipping/check_winning',
        method: 'get'
    })
}

// 获取文件上传签名
export function uploadSign(params) {
    return requestBbs({
        url: 'api/file/upload-sign',
        method: 'get',
        params
    })
}
  